import { render, staticRenderFns } from "./Actypes.vue?vue&type=template&id=18a6f56f&scoped=true"
import script from "./Actypes.vue?vue&type=script&lang=js"
export * from "./Actypes.vue?vue&type=script&lang=js"
import style0 from "./Actypes.vue?vue&type=style&index=0&id=18a6f56f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6f56f",
  null
  
)

export default component.exports